// TanStack Router instance for the LiveVane SPA.
//
// The router is instantiated from the generated route tree (produced by
// `@tanstack/router-plugin` on every dev/build cycle from the files under
// `src/routes/`). It carries the shared `queryClient` via the typed
// router context so loaders / `beforeLoad` guards on child routes can
// read `context.queryClient` without re-importing the singleton.
//
// The `Register` module augmentation gives every consumer
// (Link, useNavigate, useRouter, route definitions) full type inference
// for paths and params. Without it, navigation calls collapse to `any`.
//
// defaultPreloadStaleTime: 0
//   When the router preloads a route on intent (hover/touch), we want the
//   route loader to RUN and let react-query decide whether the cached
//   data is stale. Without this override, the router caches loader
//   results for 30s by default which would shadow react-query.
//   This is the canonical pattern when integrating TanStack Router with
//   TanStack Query — see TanStack docs "with-react-query".
import { createRouter } from '@tanstack/react-router'

import { queryClient } from '@/lib/query-client'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  // The typed router context is supplied for real at runtime by
  // <RouterProvider context={{ queryClient }} />; this default keeps the
  // type-only `Register` augmentation happy and serves as a fallback.
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
